export enum WarningTypes {
  error = "error",
  warning = "warning"
}
